(() => {
  if (customElements.get('categorized-faq')) return;
  const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[’‘]/g, "'");

  class CategorizedFaq extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.input = this.querySelector('[data-category-search]');
      this.status = this.querySelector('[data-search-status]');
      this.empty = this.querySelector('[data-search-empty]');
      this.savedOpen = new Map();
      const navigation = this.querySelector('[data-category-nav]');
      navigation?.replaceChildren();
      this.querySelectorAll('[data-faq-category]').forEach((category, index) => {
        const number = String(index + 1).padStart(2, '0');
        category.style.setProperty('--faq-category-number', '"' + number + '"');
        if (!navigation) return;
        const link = document.createElement('a');
        link.href = '#' + category.id;
        link.dataset.categoryLink = '';
        const prefix = document.createElement('span');
        prefix.textContent = number;
        const arrow = document.createElement('span');
        arrow.textContent = '↗';
        arrow.setAttribute('aria-hidden', 'true');
        link.append(prefix, document.createTextNode(category.querySelector('h3')?.textContent || ''), arrow);
        navigation.append(link);
      });
      if (navigation) navigation.hidden = !navigation.children.length;
      this.querySelector('[data-search-panel]')?.removeAttribute('hidden');
      this.input?.addEventListener('input', () => this.filter(), { signal });
      this.input?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.reset();
        }
      }, { signal });
      this.querySelector('[data-search-reset]')?.addEventListener('click', () => this.reset(), { signal });
      this.addEventListener('shopify:block:select', (event) => {
        if (this.input?.value) {
          this.input.value = '';
          this.filter();
        }
        const question = event.target.closest('[data-category-question]');
        if (question) question.open = true;
      }, { signal });
    }

    filter() {
      const words = normalize(this.input.value).trim().split(/\s+/).filter(Boolean);
      let total = 0;
      this.querySelectorAll('[data-faq-category]').forEach((category) => {
        const title = category.querySelector('h3')?.textContent || '';
        let visible = 0;
        category.querySelectorAll('[data-category-question]').forEach((question) => {
          if (words.length && !this.savedOpen.has(question)) this.savedOpen.set(question, question.open);
          const text = normalize(title + ' ' + question.textContent);
          const matches = words.every((word) => text.includes(word));
          question.hidden = !matches;
          if (words.length) question.open = matches;
          else if (this.savedOpen.has(question)) {
            question.open = this.savedOpen.get(question);
            this.savedOpen.delete(question);
          }
          if (matches) visible += 1;
        });
        category.hidden = Boolean(words.length && !visible);
        total += visible;
        this.querySelectorAll('[data-category-link]').forEach((link) => {
          if (link.hash === '#' + category.id) link.hidden = category.hidden;
        });
      });
      if (this.status) this.status.textContent = words.length ? this.dataset.countLabel.replace('[count]', total) : '';
      if (this.empty) this.empty.hidden = !words.length || total > 0;
    }

    reset() {
      this.input.value = '';
      this.filter();
      this.input.focus();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }
  customElements.define('categorized-faq', CategorizedFaq);
})();
